exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-check-container{margin-bottom:12px}.lp-label{width:140px}", ""]);

// exports
